import React from "react";
import { Box, Skeleton } from "@mui/material";

const AuditLogSkeleton = () => {
  return (
    <Box className="livis-archive-settings-table livis-audit-log-table" sx={{ width: "97%", mt: 2,bgcolor:"var(--livis-operator-builder-config-panel-bg) !important", borderRadius: 2, p: 2 }}>
      {/* Table Header Skeleton */}
      <Box sx={{ display: "flex", borderBottom: "1px solid var(--livis-ai-chat-user-bubble-border-color) !important", pb: 2, mb: 1 }}>
        <Skeleton variant="text" width="20%" height={24} sx={{ mx: 1 }} />
        <Skeleton variant="text" width="30%" height={24} sx={{ mx: 1 }} />
        <Skeleton variant="text" width="30%" height={24} sx={{ mx: 1 }} />
        <Skeleton variant="text" width="20%" height={24} sx={{ mx: 1 }} />
      </Box>
      
      {/* Table Rows Skeleton */}
      {[...Array(10)].map((_, index) => (
        <Box key={index} sx={{ display: "flex", py: 1.5, borderBottom: "1px solid var(--livis-annotation-emial-input-bg-color) !important", alignItems: 'center' }}>
          <Skeleton variant="rectangular" width="20%" height={28} sx={{ mx: 1, borderRadius: 1 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '30%', mx: 1 }}>
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="40%" height={16} />
          </Box>
          <Skeleton variant="rectangular" width="30%" height={28} sx={{ mx: 1, borderRadius: 1 }} />
          <Skeleton variant="text" width="20%" height={24} sx={{ mx: 1 }} />
        </Box>
      ))}
    </Box>
  );
};

export default AuditLogSkeleton;